import { LanguageType } from '@/models/LanguageType';
import { Person } from '@/models/Person';
import { StudentLocale } from '@/models/StudentLocale';
import { LocaleData } from '@/translations/LocaleData';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { LocaleTypes } from './types';

export const setLocale = (data: LocaleData) => action(LocaleTypes.SET, data);

export const setLocaleRequest = (person: Person) => action(LocaleTypes.SET_LOCALE_REQUEST, person);
export const setLocaleSuccess = (language: string) => action(LocaleTypes.SET_LOCALE_SUCCESS, language);
export const setLocaleFailure = (error: AxiosError) => action(LocaleTypes.SET_LOCALE_FAILURE, error);

export const setCurrentContentLanguage = (language: LanguageType) => action(LocaleTypes.SET_CURRENT_CONTENT_LANGUAGE, language);

export const setCurrentContentSubtitle = (language: LanguageType) => action(LocaleTypes.SET_CURRENT_CONTENT_SUBTITLE, language);

export const clearCurrentContentLanguage = () => action(LocaleTypes.CLEAR_CURRENT_CONTENT_LANGUAGE);

export const getContentLocaleRequest = () => action(LocaleTypes.GET_CONTENT_LOCALE_REQUEST);
export const getContentLocaleSuccess = (localeList: LanguageType[]) => action(LocaleTypes.GET_CONTENT_LOCALE_SUCCESS, localeList);
export const getContentLocaleFailure = (error: AxiosError) => action(LocaleTypes.GET_CONTENT_LOCALE_FAILURE, error);

export const setContentLocaleRequest = (studentLocaleList: StudentLocale[]) => action(LocaleTypes.SET_CONTENT_LOCALE_REQUEST, studentLocaleList);
export const setContentLocaleSuccess = (localeList: LanguageType[]) => action(LocaleTypes.SET_CONTENT_LOCALE_SUCCESS, localeList);
export const setContentLocaleFailure = (error: AxiosError) => action(LocaleTypes.SET_CONTENT_LOCALE_FAILURE, error);
